/*
 * Copyright (c) Fing. All rights reserved.
 */

import intl from 'react-intl-universal';

const ONE_MINUTE = 60000;
const ONE_HOUR = ONE_MINUTE * 60;
const ONE_DAY = ONE_HOUR * 24;
const ONE_WEEK = ONE_DAY * 7;
const ONE_MONTH = ONE_DAY * 30;
const FIVE_WEEK = ONE_WEEK * 5;
const ONE_YEAR = 365 * ONE_DAY;

const MONTH_NAMES = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];


export function formatDuration(timems, approx) {
    let secondsLeft = Math.floor(timems / 1000);
    let days = Math.floor(secondsLeft / 86400);
    secondsLeft -= (days * 86400);
    let hours = Math.floor(secondsLeft / 3600);
    secondsLeft -= (hours * 3600);
    let minutes = Math.floor(secondsLeft / 60);

    if (approx) {
        if (minutes > 45) {
            ++hours;
            minutes = 0;
        } else if ((days > 0 || hours > 0) && minutes < 15) {
            minutes = 0;
        }
        if (days > 0) {
            minutes = 0;
            if (hours <= 3) {
                hours = 0;
            } else if (hours >= 18) {
                hours = 0;
                ++days;
            }
        }
        if (hours >= 24) {
            days += hours / 24;
            hours = hours % 24;
        }
    }

    let outstr = '';

    if (days > 0) {
        outstr = outstr.concat(intl.get('time_days', { dayAmount: days }));
    }

    if ((hours > 0) /*|| (days > 0)*/) {
        if (outstr.length > 0) outstr = outstr.concat(", ");
        outstr = outstr.concat(intl.get('time_hours', { hourAmount: hours }));
    }

    if (minutes > 0 || outstr.length === 0) {
        if (outstr.length > 0) {
            outstr = outstr.concat(", ");
            outstr = outstr.concat(intl.get('time_minutes_short', { minAmount: minutes }));
        } else {
            outstr = outstr.concat(intl.get('time_minutes', { minAmount: minutes }));
        }
    }

    return outstr;
}

export function formatDateYYYYMMDD(ts) {
    let toReturn = "Invalid Date";

    try {
        // Check if the ts is without milliseconds
        ts = fixTimestampMillis(ts);

        let date = new Date(ts).toISOString();
        if (date && date.split('T') && date.split('T').length) {
            toReturn = date.split('T')[0];
            toReturn = toReturn.split('-').join("/");
        }
    } catch (e) {
        console.error('Error parse date - ', e);
    }

    return toReturn;
}

export function formatRelativeDate(timestamp, size) {

    const now = new Date().getTime();
    const oneMinAgo = now - ONE_MINUTE;
    const oneHourAgo = now - ONE_HOUR;
    const oneDayAgo = now - ONE_DAY;
    const oneWeekAgo = now - ONE_WEEK;
    const oneMonthAgo = now - (30 * ONE_DAY);
    const oneYearAgo = now - ONE_YEAR;
    const fiveWeekAgo = now - FIVE_WEEK;

    if (size === 'short') {

        if (timestamp <= 0)
            return "";
        if (timestamp > oneMinAgo)
            return intl.get('dateformat_now');
        if (timestamp > oneHourAgo)
            return intl.get('dateformat_min_short', { amount: parseInt((now - timestamp) / ONE_MINUTE + 0.5) });
        // return context.getString(R.string.dateformat_min_short, String.valueOf(parseInt((now - timestamp) / ONE_MINUTE + 0.5)));
        if (timestamp > oneDayAgo)
            return intl.get('dateformat_hour_short', { amount: parseInt((now - timestamp) / ONE_HOUR + 0.5) });
        // return context.getString(R.string.dateformat_hour_short, String.valueOf(parseInt((now - timestamp) / ONE_HOUR + 0.5)));
        if (timestamp > oneMonthAgo)
            return intl.get('dateformat_day_short', { amount: parseInt((now - timestamp) / ONE_DAY + 0.5) });
        // return context.getString(R.string.dateformat_day_short, String.valueOf(parseInt((now - timestamp) / ONE_DAY + 0.5)));

        // TODO: I18N
        return MONTH_NAMES[new Date(timestamp).getMonth()];

    } else {

        if (timestamp > oneMinAgo) {
            return intl.get('dateformat_now');
            // return context.getString(R.string.dateformat_now);
        } else if (timestamp > oneHourAgo) {
            const v = parseInt((now - timestamp) / ONE_MINUTE + 0.5);
            if (v === 1)
                return intl.get('dateformat_minago', { amount: v });
            // return context.getString(R.string.dateformat_minago, String.valueOf(v));
            return intl.get('dateformat_minsago', { amount: v });
            // return context.getString(R.string.dateformat_minsago, String.valueOf(v));
        } else if (timestamp > oneDayAgo) {
            const v = parseInt((now - timestamp) / ONE_HOUR + 0.5);
            if (v === 1)
                return intl.get('dateformat_hourago', { amount: v });
            // return context.getString(R.string.dateformat_hourago, String.valueOf(v));
            return intl.get('dateformat_hoursago', { amount: v });
            // return context.getString(R.string.dateformat_hoursago, String.valueOf(v));
        } else if (timestamp > oneWeekAgo) {
            const v = parseInt((now - timestamp) / ONE_DAY + 0.5);
            if (v === 1)
                return intl.get('dateformat_dayago', { amount: v });
            // return context.getString(R.string.dateformat_dayago, String.valueOf(v));
            return intl.get('dateformat_daysago', { amount: v });
            // return context.getString(R.string.dateformat_daysago, String.valueOf(v));
        } else if (timestamp > fiveWeekAgo) {
            const v = parseInt((now - timestamp) / ONE_WEEK + 0.5);
            if (v === 1)
                return intl.get('dateformat_weekago', { amount: v });
            // return context.getString(R.string.dateformat_weekago, String.valueOf(v));
            return intl.get('dateformat_weeksago', { amount: v });
            // return context.getString(R.string.dateformat_weeksago, String.valueOf(v));
        } else if (timestamp > oneYearAgo) {
            const v = parseInt((now - timestamp) / ONE_MONTH + 0.5);
            if (v === 1)
                return intl.get('dateformat_monthago', { amount: v });
            // return context.getString(R.string.dateformat_monthago, String.valueOf(v));
            return intl.get('dateformat_monthsago', { amount: v });
            // return context.getString(R.string.dateformat_monthsago, String.valueOf(v));
        } else {
            const v = parseInt((now - timestamp) / ONE_YEAR + 0.5);
            if (v === 1)
                return intl.get('dateformat_yearago', { amount: v });
            // return context.getString(R.string.dateformat_yearago, String.valueOf(v));
            return intl.get('dateformat_yearsago', { amount: v });
            // return context.getString(R.string.dateformat_yearsago, String.valueOf(v));
        }

    }
}

export function formatShortDate(timestamp) {
    const options = { weekday: 'short' };
    let startDate = new Date(timestamp);
    return startDate.toLocaleDateString("en-US", options);
}

export function formatShortAbsoluteDate(timestamp) {
    if (typeof timestamp === 'string') {
        timestamp = parseInt(timestamp);
    }
    timestamp = fixTimestampMillis(timestamp);
    let startDate = new Date(timestamp);

    const options = { month: 'short', year: 'numeric' };

    const locale = intl.getInitOptions().currentLocale || 'en-US';
    return startDate.toLocaleDateString(locale, options);
}

export function formatLongAbsoluteDate(timestamp) {
    if (typeof timestamp === 'string') {
        timestamp = parseInt(timestamp);
    }
    timestamp = fixTimestampMillis(timestamp);
    let startDate = new Date(timestamp);

    const options = { day: "numeric", month: 'short', year: 'numeric' };

    const locale = intl.getInitOptions().currentLocale || 'en-US';
    return startDate.toLocaleDateString(locale, options);
}

export function formatSmartAbsoluteDate(timestamp, timezone) {
    timestamp = fixTimestampMillis(timestamp);

    let nowDate = new Date();
    let nowTimestamp = nowDate.getTime();
    let within24h = (nowTimestamp - timestamp) <= 60000 * 60 * 24;
    let within30d = (nowTimestamp - timestamp) <= 60000 * 60 * 24 * 30;
    let within180d = (nowTimestamp - timestamp) <= 60000 * 60 * 24 * 180;

    let options = within24h ? { hour: 'numeric', minute: 'numeric' } :
        within30d ? { weekday: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' } :
            within180d ? { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' } :
                { month: 'short', year: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };

    if (timezone) {
        options.timeZone = timezone;
        options.timeZoneName = 'short';
    }

    const locale = intl.getInitOptions().currentLocale || 'en-US';
    let startDate = new Date(timestamp);
    return within24h ? startDate.toLocaleTimeString(locale, options) : startDate.toLocaleDateString(locale, options);
}

/**
 * Trick to understand whether the timestamp is in seconds or in milliseconds
 * N.B. As now we are in 2021 and the allowed diff is 20 years,
 *      all dates before 2001 will be considered in milliseconds
 *
 * FIXME: Put 100 years to be safe. 1970 is now more than 50 ago.
 */
function fixTimestampMillis(ts) {
    if (Math.abs(Date.now() - ts) > (20 * 365 * 86400 * 1000)) ts *= 1000;
    return ts;
}

/**
 * Convert UNIX epoch in Javascript date
 */
export function fromUnixEpoch(epoch) {
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    return new Date(epoch * 1000);
}

export function getCurrentDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = mm + '/' + dd + '/' + yyyy;

    return today;
}